import { BotId } from '@feedyou/schema'

import { RootState } from '../../reducers'
import { botTesterApi } from './botTesterApi'

export function scenarioSelector(botId: BotId, scenarioId: string) {
  return (state: RootState) => {
    const scenarios = botTesterApi.endpoints.getTesterScenarios.select({
      botId
    })(state)?.data

    return scenarios?.find(s => s.scenarioId === scenarioId)
  }
}
